module.exports = __webpack_public_path__ + "img/03.921e96c7.png";